import React from 'react';
import * as dates from '@simplybenefits/sb-dates';
import StyledTable from '../../components/StyledTable.js';
import TableHead from '@mui/material/TableHead/TableHead';
import StyledTableRow from '../../components/StyledTableRow.js';
import StyledTableCell from '../../components/StyledTableCell.js';
import TableBody from '@mui/material/TableBody/TableBody';
import { colors, fonts } from '../../theme/index.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as localizationMaps from '../../localization/maps.js';
const statusMap = {
  0: 'Pending',
  1: 'Active',
  2: 'Account Disabled',
  3: 'Parental Leave',
  4: 'Leave of Absence',
  5: 'Temporary Lay Off',
  6: 'Disability',
  7: 'Strike',
  8: 'Late Applicant',
  9: 'Terminated',
  10: 'Approved Leave',
  11: 'Survivor Benefits',
  12: 'Severance'
};

/**
 * @param number
 * @returns {string}
 * @private
 */
const _formatNumber = number => `$${(number || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

/**
 * @param census
 * @param onSelectUser
 * @param classData
 * @param divisions
 * @param styles
 * @returns {*}
 * @constructor
 */
const CensusTable = ({
  census,
  onSelectUser,
  classData,
  divisions,
  currentAccountMeta
}) => {
  const styles = {
    scrollbar: {
      scrollbar: {
        '&::-webkit-scrollbar': {
          height: '15px',
          width: '15px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: colors.surface,
          borderRadius: '10px',
          boxShadow: 'inset 0 0 2px rgba(0, 0, 0, .5)'
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: colors.backgroundGrey,
          borderRadius: '10px',
          boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.2)'
        }
      }
    },
    tableHeading: {
      fontFamily: fonts.type.medium
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      ...styles.scrollbar,
      overflow: "auto",
      maxHeight: 600
    }
  }, /*#__PURE__*/React.createElement(StyledTable, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(StyledTableRow, null, /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.classesAndDivisions.name)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.status)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.email)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.birthdate)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.employees.class)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.employees.division)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, currentAccountMeta.isStudentGroup ? i18n.t(tokens.labels.employees.studyStartDate) : i18n.t(tokens.labels.employees.hireDate)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.gender)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, currentAccountMeta.isStudentGroup ? i18n.t(tokens.labels.employees.degree) : i18n.t(tokens.labels.employees.occupation)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.planDesign.coverage)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.province)), !currentAccountMeta.isStudentGroup && /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.census.earnings)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, currentAccountMeta.isStudentGroup ? i18n.t(tokens.labels.employees.studentID) : i18n.t(tokens.labels.employees.payrollID)), currentAccountMeta.isStudentGroup ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.phoneNumber)), /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.maritalStatus))) : null, /*#__PURE__*/React.createElement(StyledTableCell, {
    style: styles.tableHeading
  }, i18n.t(tokens.labels.signup.language)))), /*#__PURE__*/React.createElement(TableBody, null, census.map(user => {
    let className = null;
    if (classData[user.classID]) {
      className = classData[user.classID].title;
    }

    // find and set the division name
    let divisionName = null;
    if (divisions[user.divisionID]) {
      divisionName = divisions[user.divisionID].title;
    }
    user.salary = Number(user.salary);
    user.hourlyWage = Number(user.hourlyWage);
    user.hoursPerWeek = Number(user.hoursPerWeek);
    const name = user.firstname ? `${user.firstname} ${user.lastname}` : null;
    const birthdate = user.birthdate ? dates.getUTC(user.birthdate, 'll') : null;
    const hireDate = user.hireDate ? dates.getUTC(user.hireDate, 'll') : null;
    const studyStartDate = user.studyStartDate ? dates.getUTC(user.studyStartDate, 'll') : null;
    const earnings = user.salary !== 0 ? user.salary : user.hourlyWage * user.hoursPerWeek * 52;
    const status = statusMap[user.status];
    const coverageType = user.coverageType;
    return /*#__PURE__*/React.createElement(StyledTableRow, {
      key: user.userID,
      hover: true,
      onClick: () => onSelectUser(user)
    }, /*#__PURE__*/React.createElement(StyledTableCell, null, name), /*#__PURE__*/React.createElement(StyledTableCell, null, localizationMaps.fromEnglish("memberStatuses", status)), /*#__PURE__*/React.createElement(StyledTableCell, null, user.email), /*#__PURE__*/React.createElement(StyledTableCell, null, birthdate), /*#__PURE__*/React.createElement(StyledTableCell, null, className), /*#__PURE__*/React.createElement(StyledTableCell, null, divisionName), /*#__PURE__*/React.createElement(StyledTableCell, null, currentAccountMeta.isStudentGroup ? studyStartDate : hireDate), /*#__PURE__*/React.createElement(StyledTableCell, null, localizationMaps.fromEnglish("genders", user.gender) || null), /*#__PURE__*/React.createElement(StyledTableCell, null, currentAccountMeta.isStudentGroup ? user.degree : user.title), /*#__PURE__*/React.createElement(StyledTableCell, null, localizationMaps.fromEnglish("coverageTypes", coverageType)), /*#__PURE__*/React.createElement(StyledTableCell, null, localizationMaps.fromEnglish("provinces", user.province)), !currentAccountMeta.isStudentGroup && /*#__PURE__*/React.createElement(StyledTableCell, null, _formatNumber(earnings)), /*#__PURE__*/React.createElement(StyledTableCell, null, currentAccountMeta.isStudentGroup ? user.studentID : user.payrollID), currentAccountMeta.isStudentGroup ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTableCell, {
      style: styles.tableHeading
    }, user.phone), /*#__PURE__*/React.createElement(StyledTableCell, {
      style: styles.tableHeading
    }, user.maritlStat)) : null, /*#__PURE__*/React.createElement(StyledTableCell, null, user.language));
  }))));
};
export default CensusTable;